import './styles.modules.scss';
import { useFormikContext } from 'formik';
import React, { useCallback, useMemo } from 'react';
import InputQuantity from '../Quantity';
import { Product, ProductType } from '~redux/brand/types';

type TypeRowsProps = {
  product: Product;
  types: ProductType[];
  isCart?: boolean;
};

const TypeRows: React.FC<TypeRowsProps> = ({ product, types, isCart }) => {
  const { values, setValues } = useFormikContext<{
    quantities: Record<string, number>;
  }>();
  const totalQuantity = useMemo(
    () =>
      Object.values(values.quantities).reduce((prev, value) => {
        const qty = Number(value);
        return prev + (isNaN(qty) ? 0 : qty);
      }, 0),
    [values.quantities]
  );
  const lot = useMemo(() => product.product_order_lot ?? 1, [product]);
  const min = useMemo(
    () =>
      Math.min(
        product.product_minimum_quantity ?? 1,
        product.product_order_lot ?? 1
      ),
    [product]
  );
  const outOfStockAll = useMemo(
    () => types.every(({ out_of_stock }) => out_of_stock),
    [types]
  );

  const incrementAll = useCallback(() => {
    const quantities = Object.entries(values.quantities).reduce(
      (prev, [key, quantity]) => {
        const type = types.find((type) => type.id === key);
        return { ...prev, [key]: quantity + (type?.out_of_stock ? 0 : lot) };
      },
      {}
    );
    setValues({ ...values, quantities });
  }, [values, lot, types]);

  const decrementAll = useCallback(() => {
    const quantities = Object.entries(values.quantities).reduce(
      (prev, [key, quantity]) => ({
        ...prev,
        [key]: Math.max(quantity - lot, 0),
      }),
      {}
    );
    setValues({ ...values, quantities });
  }, [values, lot]);

  return (
    <div className="mb-4">
      {types.map((type) => {
        return (
          <div styleName="single-type-row" key={type.id}>
            <div>{type.size || type.color || type.type_name}</div>
            <div styleName="qty">
              <InputQuantity
                name={type.id}
                minimum={min}
                lot={lot}
                brandId={product.product_brand_id!}
                productId={product.id!}
                productTypeId={type.id}
                sku={type.sku!}
                cart={isCart}
              />
            </div>
          </div>
        );
      })}
      {!outOfStockAll && (
        <div styleName="single-type-row">
          <div>合計</div>
          <div styleName="total-qty">
            <button
              type="button"
              tabIndex={-1}
              onClick={decrementAll}
              className="bg-white mr-2"
              style={{
                border: 0,
                width: '30px',
                padding: '5px 0',
              }}
            >
              -
            </button>
            <div className="mr-2" style={{ width: '60px' }}>
              {totalQuantity}
            </div>
            <button
              type="button"
              tabIndex={-1}
              onClick={incrementAll}
              className="bg-white"
              style={{
                border: 0,
                width: '30px',
                padding: '5px 0',
              }}
            >
              +
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TypeRows;
